import axios from 'axios'
import * as Sentry from '@sentry/browser'
import { itemConditionHelper } from '../store/helpers'
import store from '../store/index'

const request = async (method, url, requestData) => {
  try {
    const { data } = await axios({
      baseURL: process.env.VUE_APP_API_SERVER_BASE_URL,
      method,
      url,
      data: requestData
    })
    return Promise.resolve(data)
  } catch (error) {
    if (error) {
      // eslint-disable-line no-console
      Sentry.captureException(error)

      return Promise.reject(error)
    }
  }
}

export default {
  getSurveys (surveys) {
    surveys.forEach((survey) => {
      this.getSurvey(survey.hash)
        .then(surveySurvey => {
          survey.survey = surveySurvey
        })
        .catch(() => {
          //
        })
    })

    return surveys
  },
  getSurvey (surveyHash) {
    return request('get', `/api/v3/surveys/${surveyHash}`)
      /*
      @todo Handle this transformation on the back-end
       */
      .then((response) => {
        let survey = response.data.survey

        survey.hash = surveyHash

        let allItems = survey.pages.reduce((acc, page) => acc.concat(page.items), [])

        survey.pages.map(page => {
          page.items = page.items.map(item => {
            item.value = null
            item.show = true
            return item
          })
          page.items = page.items.sort((a, b) => a.order - b.order)
          page.items = [ ...itemConditionHelper(page.items, allItems) ]

          return page
        })

        survey.pages = survey.pages.sort((a, b) => a.order - b.order)

        return survey
      })
  },
  submitSurvey (surveyHash, data, responseId) {
    if (!navigator.onLine) {
      return this.storeSurveyResponseLocally(surveyHash, data, responseId)
    } else {
      return this.submitSurveyResponse(surveyHash, data, responseId)
    }
  },
  submitSurveyResponse (surveyHash, data, responseId) {
    if (responseId) {
      return request('put', `/api/v3/surveys/${surveyHash}/responses/${responseId}`, data)
    }
    return request('post', `/api/v3/surveys/${surveyHash}/responses`, data)
  },
  submitSurveyPage (surveyHash, data, responseId) {
    if (responseId !== null) {
      return request('put', `/api/v3/surveys/${surveyHash}/responses/${responseId}`, data)
    }
    return request('post', `/api/v3/surveys/${surveyHash}/responses`, data)
  },
  getPendingSurveys () {
    let surveys = []
    let keys = this.findOfflineKeys()

    keys.forEach((key) => {
      // check if we have saved data in localStorage.
      const survey = JSON.parse(localStorage.getItem(key))
      surveys.push(survey)
    })
    return surveys
  },
  storeSurveyResponseLocally (surveyHash, data, responseId) {
    // check if localStorage is available.
    if (typeof Storage === 'undefined') {
      return false
    }

    const entry = {
      time: new Date().getTime(),
      hash: surveyHash,
      response_id: responseId,
      data: data
    }

    let key = `survey-${surveyHash}-${entry.time}`

    // save data as JSON string.
    localStorage.setItem(key, JSON.stringify(entry))
    return true
  },
  findOfflineKeys () {
    let keys = []

    for (let i = 0, len = localStorage.length; i < len; ++i) {
      let key = localStorage.key(i)
      if (key.lastIndexOf('survey', 0) === 0) {
        keys.push(key)
      }
    }
    return keys
  },
  submitFromStorage () {
    if (typeof Storage !== 'undefined') {
      let keys = this.findOfflineKeys()

      keys.forEach((key) => {
      // check if we have saved data in localStorage.
        const item = localStorage.getItem(key)
        const entry = item && JSON.parse(item)

        if (entry && entry.hasOwnProperty('hash') && entry.hasOwnProperty('data')) {
        // discard submissions older than one day. (optional)
          this.submitSurveyResponse(entry.hash, entry.data).then(() => {
            localStorage.removeItem(key)
            store.dispatch('submitPendingSurvey')
          })
        }
      })
    }
  }
}
